import React, { useEffect, useState } from "react";
import Slider from 'react-slick';
import ImageAutomation from "../../images/real-time-planning.png";
import ImageAutomationMobile from "../../images/real-time-planning.png";

import ImageWarehouse1 from "../../images/warehouse-exp-img-1.png";
import ImageWarehouse2 from "../../images/warehouse-exp-img-2.png";
import ImageWarehouse2Element from "../../images/warehouse-exp-img-2-element.png";
import ImageWarehouse3 from "../../images/warehouse-exp-img-3.png";
import ImageWarehouse3Element from "../../images/warehouse-exp-img-3-element.png";

import IconDigitalLoadingSheet from "../../icons/icon-digital-loading-sheet.svg";
import IconBarcodeScanning from "../../icons/icon-barcode-scanning.svg";

import ImageDriverExperience from "../../images/driver-experience.png";

import IconCustomerInformation from "../../icons/icon-customer-information.svg";
import IconOfflineMode from "../../icons/icon-offline-mode.svg";
import IconProofDelivery from "../../icons/icon-proof-delivery.svg";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";

export default function Automation() {
  const [isVisible, setisVisible] = useState(false);
  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 1000,
    cssEase: 'linear'
  };

  return (
    <div className="cb-deliveries">
      <div className="wave-bg"></div>
      <div className="container">
        <div className="deliveries-top section-gap-large">
          <div className="cb-deliveries-content">

            <h2>Real-time planning and monitoring of all deliveries</h2>
            <p>All stakeholders and, most importantly, the drivers must always be updated and guided with the information and changing conditions at every step of the delivery process, including the route plans, customer availabilities, traffic, and next deliveries.</p>

            <p>With customer addresses, warehouses, and fleet’s geo-coded data, the shipping managers can quickly devise the most efficient delivery methods and trips in minutes. With fleet and shipment tracking features on the web app, the managers can monitor the live location of each order on the live map view. They can immediately respond to exceptions such as rescheduling, returns, and route changes.</p>
          </div>

          <Parallax classes="cb-deliveries-image" id="cb-deliveries-image" triggers={[1.2, 0.4]} length={250}>
            {!isMobile && <>
              <img src={ImageAutomation} title="real time delivery tracking" alt="real time delivery tracking" />
            </>}
            {isMobile && <>
              <img src={ImageAutomationMobile} title="real time delivery tracking" alt="real time delivery tracking" />
            </>}
          </Parallax>
        </div >
        <div className="warehouse-experience section-gap">
          <div className="align-v-center d-flex flex-wrap row">

            <div className="col cb-warehouse-experience-image">
              <Parallax classes="image-1" id="warehouse-image1" opacity={true} triggers={[1.3, 0.6]} direction={directions.LTR}>
                <img src={ImageWarehouse1} title="dispatch and loading" alt="dispatch and loading" />
              </Parallax>
              <Parallax classes="image-2" id="warehouse-image2" opacity={true} triggers={[1.3, 0.6]} direction={directions.RTL}>
                <img src={ImageWarehouse2} title="dispatch and loading" alt="dispatch and loading" />
                <div className="image-2-element">
                  <img src={ImageWarehouse2Element} title="dispatch and loading" alt="dispatch and loading" />
                </div>
              </Parallax>
              <Parallax classes="image-3" id="warehouse-image3" opacity={true} triggers={[1.3, 0.6]} direction={directions.LTR}>
                <img src={ImageWarehouse3} title="dispatch and loading" alt="dispatch and loading" />
                <div className="image-3-element">
                  <img src={ImageWarehouse3Element} title="dispatch and loading" alt="dispatch and loading" />
                </div>
              </Parallax>
            </div>

            <InView as="div" className="col cb-warehouse-experience-content" onChange={(inView) => setisVisible(inView)}>
              <h2 className="theme-color-title cb-blue-color-1">{isVisible ? <HeaderAnim header="WAREHOUSE EXPERIENCE" /> : "WAREHOUSE EXPERIENCE"}</h2>
              <h3>Dispatch & Loading</h3>
              <p>The warehouse staff had to decide which and how many products to load manually, in which trucks, in which order, and track it all with a paper-based process. We saved the client hundreds of hours of manpower at each warehouse by digitizing and automating these manual and repetitive processes with an intuitive mobile app for warehouse staff.</p>
              <div className="warehouse-icon">
                <div className="two-column-item">
                  <div className="item-inner d-flex">
                    <div className="item-icon">
                      <i><IconDigitalLoadingSheet /></i>
                    </div>
                    <div className="item-content">
                      <h4 className="h5">Digital Loading Sheet</h4>
                      <p>As the shipments are planned on the platform, the warehouse staff gets automated instructions on their mobile app regarding the products to load in the trucks and the order they can be loaded in.</p>
                    </div>
                  </div>
                </div>
                <div className="two-column-item">
                  <div className="item-inner d-flex">
                    <div className="item-icon">
                      <i><IconBarcodeScanning /></i>
                    </div>
                    <div className="item-content">
                      <h4 className="h5">Barcode Scanning</h4>
                      <p>Replaces the paper-based process with digital barcodes that track each product and shipment in the mobile app.</p>
                    </div>
                  </div>
                </div>
              </div>
            </InView >
          </div >
        </div >

        <div className="driver-experience">
          <div className="align-end d-flex flex-wrap row">

            <div className="col cb-driver-experience-content">
              <h3>Driver Experience</h3>
              <p>As the last stretch of the delivery process,  drivers need to have the most up-to-date information during delivery trips.</p>
              <div className="driver-icon">
                <div className="two-column-item">
                  <div className="item-inner d-flex">
                    <div className="item-icon">
                      <i><IconOfflineMode /></i>
                    </div>
                    <div className="item-content">
                      <h4 className="h5">Offline Mode</h4>
                      <p>Continue to deliver products in the areas without network or internet coverage - the app downloads data for offline use and automatically syncs it later.</p>
                    </div>
                  </div>
                </div>
                <div className="two-column-item">
                  <div className="item-inner d-flex">
                    <div className="item-icon">
                      <i><IconCustomerInformation /></i>
                    </div>
                    <div className="item-content">
                      <h3 className="h5">Customer Information</h3>
                      <p>Ensuring safe and secure deliveries by scanning the barcode both at the time of pickup and delivery.</p>
                    </div>
                  </div>
                </div>
                <div className="two-column-item">
                  <div className="item-inner d-flex">
                    <div className="item-icon">
                      <i><IconProofDelivery /></i>
                    </div>
                    <div className="item-content">
                      <h4 className="h5">Proof of Delivery</h4>
                      <p>Digitized proof of delivery documents ensure efficient operations, less manual labor, and easy access.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Parallax classes="col cb-driver-experience-image" id="cb-driver-experience-image" triggers={[1.2, 0.5]} opacity={true} length={200} direction={directions.RTL}>
              <img src={ImageDriverExperience} title="Driver Experience" alt="Driver Experience" />
            </Parallax>
          </div>
        </div>
      </div >
    </div >
  );
}
